import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Centralized SEO component — manages title, meta tags, canonical, hreflang,
 * Open Graph, Twitter Card and JSON-LD per route.
 */
const SEOHead = ({
  title,
  description,
  canonical,
  keywords,
  image = "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/qilc77hi_logo%20imoteps.png",
  lang = "fr",
  type = "website",
  jsonLd,
  noindex = false,
}) => {
  const fullCanonical = canonical
    ? canonical.startsWith("http")
      ? canonical
      : `https://imoteps.doctor${canonical}`
    : "https://imoteps.doctor/";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"}
      />
      <link rel="canonical" href={fullCanonical} />

      {/* Hreflang FR / EN */}
      <link rel="alternate" hrefLang="fr" href={fullCanonical} />
      <link rel="alternate" hrefLang="x-default" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={lang === "fr" ? "fr_FR" : "en_US"} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="IMOTEpS — Dr Richard Aswad" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
